import React, { type ReactNode } from 'react';

type AddressColumnModel = { city: string; state: string; zipCode: string; addressOne: string };

export function RenderAddressCell({ address }: { address: AddressColumnModel | undefined }): ReactNode {
	if (!address) {
		return null;
	}
	return (
		<div className="flex flex-col">
			<div className="text-sm text-gray-900">{address.addressOne}</div>
			<div className="text-xs text-gray-500">
				{address.city}, {address.state} {address.zipCode}
			</div>
		</div>
	);
}
